// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/global.css';



import { CartProvider } from './context/CartContext';

// ✅ Import BrowserRouter
import { BrowserRouter } from 'react-router-dom';

// ✅ Configure Amplify


// ✅ Create root and render app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* ✅ Wrap App in BrowserRouter to enable routing */}
    <BrowserRouter>
      <CartProvider>
        <App />
      </CartProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// ✅ Report performance
reportWebVitals();